import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customQueueBoardRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-board',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
	exact: true,
};
